
export interface UserInterface {
    id: String
    username: String
    email: String
    firstname: String
    lastname: String
    country: String
    language: String
    currency: String
    owner_id: String
    site_id: String
    external_id: String
    level_id: String
    status: String
    created_at: String
    updated_at: String
    balance: String
    params: Array<Object>
    balance_usd: Number
    poker: Boolean
}
export class User {

    public id: String;
    public username: String;
    public email: String;
    public firstname: String;
    public lastname: String;
    public country: String;
    public language: String;
    public currency: String;
    public owner_id: String;
    public site_id: String;
    public external_id: String;
    public level_id: String;
    public status: String;
    public created_at: String;
    public updated_at: String;
    public balance: String;
    public params: Array<Object>;
    public balance_usd: Number;
    public poker:Boolean;

    constructor(private userObject: UserInterface) {
        this.id = userObject.id;
        this.username = userObject.username;
        this.email = userObject.email;
        this.firstname = userObject.firstname;
        this.lastname = userObject.lastname;
        this.country = userObject.country;
        this.language = userObject.language;
        this.currency = userObject.currency;
        this.owner_id = userObject.owner_id;
        this.site_id = userObject.site_id;
        this.external_id = userObject.external_id;
        this.level_id = userObject.level_id;
        this.status = userObject.status;
        this.created_at = userObject.created_at;
        this.updated_at = userObject.updated_at;
        this.balance = userObject.balance;
        this.params = userObject.params;
        this.balance_usd = userObject.balance_usd;
        this.poker = userObject.poker;
    }
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/Models/User/user.ts